module.exports = __webpack_public_path__ + "static/media/ventfilersft.7673f4c2.png";